import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService } from 'lib/ng2-sapmp/src/providers';


@Injectable()
export class GridService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService) { }

  fetchGridData(dataurl) {

    return this.httpClientService.get(dataurl)
      .pipe(
       map((test: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(test);
        return test.body;
      })
      ,catchError( this.handleError ));
  }


  handleError = (error) => {
    return throwError(error);
  }

}

